
import React from 'react'
import './About.css'
import suv from  '../../images/suv.png'
import mission from  '../../images/mission.jpg'
import vission from  '../../images/vission.jpeg'
import driver from  '../../images/driver.webp'
import custom from  '../../images/custom.jpg'

function About() {
  return (
    <div className='about'>
        <div className="page">
            <div className="hero">
                <div className="content">
                    <div className="text">
                        <p>We Are Creating A World Where</p>
                        <h1> <span>luxurious Rides</span>  Are Easier To Book Than Ever</h1>
                    </div>
                </div>
            </div>
            <div className="con">
                <div className="two">
                    <div className="story">
                        <div className="image">
                            <img src={suv} alt="car" />
                        </div>
                        <div className="text">
                            <h3>Our Story</h3>
                            <p>In a world where more people want to avoid driving, traffic & parking hassles. Yet want the essence of luxury rides. Go Limo is here to make it easier than ever to book a limousine. We empower the community with eco-friendly transportation that is luxurious in every detail.</p>
                        </div>
                    </div>
                    <div className="mission">
                        <div className="left">
                            <div className="image">
                                <img src={vission} alt="" />
                            </div>
                            <div className="text">
                                <h3>Our Vision</h3>
                                <p>Go Limo was established as a member of the Go Bus Company Group. With the vision to elevate our customers' limousine experience and lead eco-friendly luxury transportation in Egypt.</p>
                            </div>
                        </div>
                        <div className="left rs">
                            <div className="image">
                                <img src={mission} alt="" />
                            </div>
                            <div className="text">
                                <h3>Our Mission</h3>
                                <p>We offer our customers a seamless luxury customer experience with every interaction with Go Limo, With an easy-to-use website, complete transparency, and real-time tracking.</p>
                            </div>
                        </div>
                    </div>
                    <div className="promise">
                        <div className="text">
                            <h3>Our Promise</h3>
                            <p>We promise to be your most reliable transportation choice.</p>
                        </div>
                    </div>
                    <div className="team">
                        <div className="top">
                            <h3>Our Team</h3>
                            <p>Meet our success makers. A team of innovation & transformation passionates. A team ready to change the luxury transportation world.</p>
                        </div>
                        <div className="member">
                            <div className="left">
                                <div className="image">
                                    <img src={custom} alt="" />
                                </div>
                                <div className="text">
                                    <h3>Customer Service</h3>
                                    <p>You are in good hands with our 24/7 customer support team. Prepared to answer all your inquiries.</p>
                                </div>
                            </div>
                            <div className="left mat">
                                <div className="image">
                                    <img src={driver} alt="" />
                                </div>
                                <div className="text">
                                    <h3>Chauffeurs</h3>
                                    <p>We teamed up with the most highly trained professional drivers with the highest communication skills, driving skills, and safety standards. Enjoy a safe ride with no detours & real-time tracking.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default About